import {
  BaseEntityDTO,
  RubricFieldDTO,
  IBaseEntityDTO,
  IRubricFieldDTO,
  ISubmissionRubricFormDTO,
  SubmissionRubricFormDTO,
} from '.';

export interface ISubmissionRubricFormFieldDTO extends IBaseEntityDTO {
  submissionRubricForm: ISubmissionRubricFormDTO;
  rubricField: IRubricFieldDTO;
  value: string;
  isValid(): boolean;
}

export class SubmissionRubricFormFieldDTO
  extends BaseEntityDTO
  implements ISubmissionRubricFormFieldDTO
{
  submissionRubricForm: ISubmissionRubricFormDTO;
  rubricField: IRubricFieldDTO;
  value: string;
  constructor(data?: Partial<ISubmissionRubricFormFieldDTO>) {
    super();
    this.submissionRubricForm = new SubmissionRubricFormDTO(data?.submissionRubricForm);
    this.rubricField = new RubricFieldDTO(data?.rubricField);
    this.value = data?.value || '';
  }
  isValid = (): boolean => {
    let valid = true;
    if (this.rubricField.is_required && this.value == '') {
      valid = false;
    }
    return valid;
  };
}
